import { useEffect, useState } from "react";
import api, { API } from "../lib/api";
import Reveal, { Eyebrow } from "./Reveal";
import { GALLERY_CATEGORIES } from "../constants/content";

const catLabel = (slug) => GALLERY_CATEGORIES.find((c) => c.slug === slug)?.label || slug;

export default function PhotoGallery() {
  const [photos, setPhotos] = useState(null);
  const [cat, setCat] = useState("all");

  useEffect(() => {
    api.get("/gallery").then((r) => setPhotos(r.data)).catch(() => setPhotos([]));
  }, []);

  if (!photos || photos.length === 0) return null;

  const presentCats = GALLERY_CATEGORIES.filter((c) => photos.some((p) => p.category === c.slug));
  const visible = cat === "all" ? photos : photos.filter((p) => p.category === cat);

  return (
    <section data-testid="photo-gallery-section" className="py-14 md:py-20 bg-white border-t border-line">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        <Reveal>
          <Eyebrow>Photo Gallery</Eyebrow>
          <h2 className="mt-4 font-display font-bold text-3xl md:text-4xl tracking-tight text-ink display-expanded leading-[1.05]">
            From Our Recent Jobs
          </h2>
        </Reveal>
        {presentCats.length > 1 && (
          <div className="flex flex-wrap gap-2 mt-8 mb-8" data-testid="gallery-public-filters">
            {[{ slug: "all", label: "All" }, ...presentCats].map((c) => (
              <button key={c.slug} onClick={() => setCat(c.slug)} data-testid={`gallery-public-filter-${c.slug}`} className={`font-mono text-[10px] tracking-[0.14em] uppercase px-3.5 py-2 border transition-colors ${cat === c.slug ? "bg-ink text-white border-ink" : "border-line text-slate2 hover:border-ink hover:text-ink bg-white"}`}>
                {c.label}
              </button>
            ))}
          </div>
        )}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {visible.map((p, i) => (
            <Reveal key={p.id} delay={(i % 4) * 0.05}>
              <figure data-testid={`gallery-item-${p.id}`} className="group border border-line bg-paper overflow-hidden">
                <div className="overflow-hidden">
                  <img src={`${API}/gallery-media/${p.id}`} alt={p.title || "Razor Build project photo"} loading={i > 3 ? "lazy" : "eager"} className="w-full aspect-square object-cover img-duotone transition-transform duration-700 group-hover:scale-105" />
                </div>
                <figcaption className="px-3.5 py-3">
                  <p className="text-xs font-semibold text-ink truncate">{p.title}</p>
                  <p className="font-mono text-[9px] tracking-[0.14em] uppercase text-slate2 mt-1">{catLabel(p.category)}</p>
                  {p.description && <p className="text-[11px] text-slate2 mt-1.5 leading-relaxed">{p.description}</p>}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
